import React from 'react';
import I18n from 'i18n-js';
import { tv } from 'tailwind-variants';
import styles from '@/components/shared/LessonOverview/Cards/Cards.module.scss';
import { CARDS_ROW_REFLOW } from '@/components/shared/LessonOverview/Cards/reflowStyles';
import TeacherCard from '@/components/shared/LessonOverview/Staffer/TeacherCard';
import { StafferSlideShows } from '@/types/api/LessonOverview';
import useFlags from '@/hooks/useFlags';

interface TeacherSlideShowsProps {
  hideTabs: boolean;
  lessonId: number;
  programId: number;
  slideShows: StafferSlideShows;
  stafferId: number;
}

const cardsStyles = tv({
  base: styles.cards,
  variants: {
    reflow: {
      true: CARDS_ROW_REFLOW,
    },
  },
});

const TeacherSlideShows = ({
  hideTabs, lessonId, programId, slideShows, stafferId,
}: TeacherSlideShowsProps) => {
  const { accessibilityReflow } = useFlags();

  if (slideShows.staffer.length === 0) {
    return (
      <div
        aria-label={I18n.t('my_slideshows')}
        className={styles.placeholder}
        id="mySlideshowsContainer"
        role="region"
        tabIndex={-1}
      >
        <p>You haven&apos;t customized any slideshows yet.</p>
        <p>You can edit a slideshow and make it your own! Any slideshows you edit and save will show up here.</p>
      </div>
    );
  }

  return (
    <div
      aria-label={I18n.t('my_slideshows')}
      className={cardsStyles({ reflow: accessibilityReflow })}
      id="mySlideshowsContainer"
      role="region"
      tabIndex={-1}
    >
      {slideShows.staffer.map(slideShow => (
        <TeacherCard
          key={slideShow.id}
          hideTabs={hideTabs}
          lessonId={lessonId}
          programId={programId}
          slideShow={slideShow}
          stafferId={stafferId}
          teacherInitials={slideShow.stafferInitials}
        />
      ))}
    </div>
  );
};

export default TeacherSlideShows;
